import { EventEmitter, Injectable } from "@angular/core";
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from "@angular/router";
import { CommandService } from '@core/services/command.service';
import { PlatformCommand } from "@shared/commands/command-base";
import { IPlatformToolHandler } from "@shared/components/platform-tool/platform-tool-container/platform-tool-component";
import { InvalidateSubject } from "@shared/helpers/invalidate.subject";
import { MagicLinkModel, TabModel } from "@shared/models/platform-tool-models";
import { take } from 'rxjs';
import { SpreadsheetCommandFactory } from '../spreadsheet-command';
import { FuseSplashScreenService } from './../../../barebone-fuse/@fuse/services/splash-screen.service';
import { FlexSheetService } from './flex-sheet.service';
import {FlexSheetNavigationService} from "@features/spreadsheet/services/flex-sheet-navigation.service";

@Injectable({
    providedIn: 'root'
})
export class WorkbookSearchGridHandler implements IPlatformToolHandler {
    invalidateSubject: InvalidateSubject;
    magicLinkModel: MagicLinkModel;
    magicLinkModelValueChanged: EventEmitter<any>;
    activatedRoute?: ActivatedRoute;
    metaData?: any;

    constructor(
        private flexSheetService: FlexSheetService,
        private fuseSplashScreenService: FuseSplashScreenService,
        private commandService: CommandService,
        private dialogRef: MatDialog,
        private flexSheetNavigationService: FlexSheetNavigationService
    ) {
        this.invalidateSubject = new InvalidateSubject();
    }


    executeCommand(command: PlatformCommand, callBack?: any) {
        throw new Error("Method not implemented.");
    }

    valueChanged($event: any) {
        if ($event.item.id) {
            this.navigateToWorksheet($event);
        }
    }

    navigateToWorksheet($event: any) {
        this.fuseSplashScreenService.show();
        const item = $event.item.cells;
        const col = Number(item["Col"].value);
        const row = Number(item["Row"].value);
        const index = this.flexSheetService.getFlexSheet().selectedSheetIndex;

        this.commandService.executePlatformCommand(SpreadsheetCommandFactory.NavigateToPaginatedPageByCellCommand(
            this.flexSheetService.getCurrentWorkBookSetId(),
            this.flexSheetService.getCurrentWorkSheet().id,
            row,
            col
        )).pipe(take(1)).subscribe(async response => {
            this.dialogRef.closeAll();
            await this.flexSheetNavigationService.navigateToPaginatedWorksheetPage(
                index,
                Number(response.fieldValues['GridRow']),
                Number(response.fieldValues['GridCol']),
                Number(response.fieldValues['Row']),
                Number(response.fieldValues['Col']),
            );
            this.fuseSplashScreenService.hide();
        })
    }

    setSelectedTab(selectedTab: TabModel): void {
        throw new Error("Method not implemented.");
    }

    destroy(): void {
        this.invalidateSubject.close();
    }
}
